import { ChromeHeading, GoldText, Badge } from "../funnel";
import { EVENT_DAY_LABEL } from "../../config/event";

export const RegisteredHero = () => (
  <section className="relative overflow-hidden" data-testid="registered-hero-section">
    <div className="breathe-glow pointer-events-none absolute left-1/2 top-16 h-[620px] w-[min(1000px,140vw)] -translate-x-1/2" aria-hidden="true" />
    <div className="gutter relative flex flex-col items-center pb-20 pt-12 text-center sm:pt-16">
      <Badge size={96} className="fade-up rounded-xl shadow-[0_0_40px_rgba(232,184,74,0.55)]" data-testid="registered-badge" />
      <ChromeHeading as="h1" className="fade-up mt-8 max-w-4xl text-[44px] [animation-delay:100ms] sm:text-6xl lg:text-7xl" data-testid="registered-headline">
        You're in for <GoldText>{EVENT_DAY_LABEL}</GoldText>
      </ChromeHeading>
      <p className="fade-up mt-6 max-w-xl text-[15px] leading-relaxed text-[#cfc7b6] [animation-delay:200ms] sm:text-lg" data-testid="registered-subheadline">
        Watch this 2-minute welcome from Jay so you know exactly what happens next.
      </p>
      <div className="fade-up mt-10 w-full max-w-[460px] [animation-delay:300ms]">
        <video src="/assets/welcome-video.mp4" poster="/assets/welcome-video-poster.jpg" controls playsInline preload="metadata" className="block aspect-[4/5] w-full rounded-xl border border-[var(--gold)] bg-black object-cover shadow-[0_0_60px_-6px_rgba(232,184,74,0.5)]" data-testid="welcome-video" aria-label="Welcome from Jay" />
      </div>
    </div>
  </section>
);
